import { api, buildStorefrontApiPath } from "@/lib/api";

export type WishlistProductDTO = {
  id: string;
  slug: string;
  name: string;
  description: string | null;
  price: number;
  currency: string;
  stock: number;
  active: boolean;
  imageUrl: string | null;
};

export type WishlistItemDTO = {
  id: string;
  productId: string;
  createdAt: string;
  priceAtAdd: number;
  priceChanged: boolean;
  priceDirection: "UP" | "DOWN" | "SAME";
  priceDiff: number;
  discountPercent: number | null;
  product: WishlistProductDTO;
};

type WishlistResponse =
  | {
      items?: WishlistItemDTO[];
      total?: number;
    }
  | {
      data?: {
        items?: WishlistItemDTO[];
        total?: number;
      };
    };

function unwrapItems(input: WishlistResponse): WishlistItemDTO[] {
  const payload = (input as any)?.data ?? input;
  return Array.isArray(payload?.items) ? payload.items : [];
}

export async function fetchWishlist(
  accessToken?: string | null,
): Promise<WishlistItemDTO[]> {
  const res = await api.get<WishlistResponse>(
    buildStorefrontApiPath("/me/wishlist"),
    {
      headers: accessToken
        ? { Authorization: `Bearer ${accessToken}` }
        : undefined,
    },
  );
  return unwrapItems(res.data);
}

export async function addToWishlist(
  productId: string,
  accessToken?: string | null,
): Promise<void> {
  await api.post(
    buildStorefrontApiPath(`/me/wishlist/${productId}`),
    {},
    {
      headers: accessToken
        ? { Authorization: `Bearer ${accessToken}` }
        : undefined,
    },
  );
}

export async function removeFromWishlist(
  productId: string,
  accessToken?: string | null,
): Promise<void> {
  await api.delete(buildStorefrontApiPath(`/me/wishlist/${productId}`), {
    headers: accessToken
      ? { Authorization: `Bearer ${accessToken}` }
      : undefined,
  });
}

export async function clearWishlist(
  accessToken?: string | null,
): Promise<void> {
  await api.delete(buildStorefrontApiPath("/me/wishlist"), {
    headers: accessToken
      ? { Authorization: `Bearer ${accessToken}` }
      : undefined,
  });
}